import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import { MANIFEST } from './capabilityManifest';

const PARTS_TO_SHOW_PATH = 'ops_dashboard_config.parts_to_show';

type Has = (key: string) => boolean;

const COARSE_FALLBACKS = [
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.transport.route.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.transport.route.update` },
  { to: 'referral_program_bulk_create', from: 'rider_referral_update' },
  { to: 'referral_program_sample_download', from: 'rider_referral_update' },
  { to: 'referral_condition_bulk_create', from: 'rider_referral_update' },
  { to: 'referral_condition_sample_download', from: 'rider_referral_update' },
  { to: 'joining_bonus_bulk_create', from: 'joining_bonus_update' },
  { to: 'joining_bonus_sample_download', from: 'joining_bonus_update' },
  { to: `${PARTS_TO_SHOW_PATH}.show_start_ist_sim_tracking_button_permission`, from: `${PARTS_TO_SHOW_PATH}.show_start_sim_tracking_button_permission` },
  { to: 'allow_supplementory_services_mark_accepted', from: 'allow_supplementory_services_update' },
  { to: 'allow_supplementory_services_mark_rejected', from: 'allow_supplementory_services_update' },
  { to: 'allow_supplementory_services_mark_cancelled', from: 'allow_supplementory_services_read' },
  { to: 'allow_supplementory_services_mark_fulfilled', from: 'allow_supplementory_services_read' },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.tat.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.tat.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.tat.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.tat.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.serviceability.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.serviceability.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.serviceability.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.serviceability.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.destination.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.destination.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.destination.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.destination.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.holidayv2.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.holidayv2.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.holidayv2.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.booking_master_v2.holidayv2.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.edit`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.createInstant`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.adhoc_update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.editInstant`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.roster.adhoc_update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.read`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.edit`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.roster_management_v2.template.update` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.create`, from: `${PARTS_TO_SHOW_PATH}.allow_bag_operations` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.debag`, from: `${PARTS_TO_SHOW_PATH}.allow_bag_operations` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.inscan`, from: `${PARTS_TO_SHOW_PATH}.allow_manual_mm_bag_scan` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.outscan`, from: `${PARTS_TO_SHOW_PATH}.allow_manual_mm_bag_scan` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.delete`, from: `${PARTS_TO_SHOW_PATH}.allow_manual_mm_bag_scan` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.assignCarrier`, from: `${PARTS_TO_SHOW_PATH}.allow_manual_mm_bag_scan` },
  { to: `${PARTS_TO_SHOW_PATH}.bag_actions.handover`, from: `${PARTS_TO_SHOW_PATH}.allow_manual_mm_bag_scan` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.gateIn`, from: `${PARTS_TO_SHOW_PATH}.gate_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.gateOut`, from: `${PARTS_TO_SHOW_PATH}.gate_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.hubArrival`, from: `${PARTS_TO_SHOW_PATH}.hub_arrival_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.dockInScan`, from: `${PARTS_TO_SHOW_PATH}.dock_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.dockOutScan`, from: `${PARTS_TO_SHOW_PATH}.dock_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.dockAssign`, from: `${PARTS_TO_SHOW_PATH}.dock_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.load`, from: `${PARTS_TO_SHOW_PATH}.vehicle_loading_unloading` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.unload`, from: `${PARTS_TO_SHOW_PATH}.vehicle_loading_unloading` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_actions.freeze`, from: `${PARTS_TO_SHOW_PATH}.vehicle_loading_unloading` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_attendance_actions.present`, from: `${PARTS_TO_SHOW_PATH}.show_vehicle_attendance_update` },
  { to: `${PARTS_TO_SHOW_PATH}.vehicle_attendance_actions.absent`, from: `${PARTS_TO_SHOW_PATH}.show_vehicle_attendance_update` },
  { to: 'routing_playground_create_profile', from: 'routing_playground_update' },
  { to: 'routing_playground_update_profile', from: 'routing_playground_update' },
  { to: 'routing_playground_create_territory_profile', from: 'routing_playground_update' },
  { to: 'routing_playground_update_territory_profile', from: 'routing_playground_update' },
  { to: 'routing_playground_delete_territory_profile', from: 'routing_playground_update' },
  { to: 'routing_playground_update_master_config', from: 'routing_playground_update' },
  { to: 'routing_playground_update_hub_strategy_bulk', from: 'routing_playground_update' },
  { to: 'rider_application_update', from: 'rider_application_approval_view' },
  { to: 'rider_application_bulk_approve', from: 'rider_application_approval_view' },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.create`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.edit`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.delete`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.createHubMapping`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.updateHubMapping`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.createHubMappingBulk`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.disableHubMappingBulk`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_master.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.initiateAllocationBulk`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.submitAllocation`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.update` },
  { to: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.cancelAllocation`, from: `${PARTS_TO_SHOW_PATH}.setup_permission_obj.equipment_allocation.update` },
  { to: `${PARTS_TO_SHOW_PATH}.shelf_add_consignment`, from: `${PARTS_TO_SHOW_PATH}.shelf_update` },
  { to: `${PARTS_TO_SHOW_PATH}.shelf_remove_consignment`, from: `${PARTS_TO_SHOW_PATH}.shelf_update` },
  { to: `${PARTS_TO_SHOW_PATH}.shelf_remove_consignment_bulk`, from: `${PARTS_TO_SHOW_PATH}.shelf_update` },
];

export const applyGranularFallbacks = (masterData: any): void => {
  if (!masterData || typeof masterData !== 'object') return;
  COARSE_FALLBACKS.forEach((fallback) => {
    const fromValue = get(masterData, fallback.from);
    if (fromValue !== undefined && get(masterData, fallback.to) === undefined) {
      set(masterData, fallback.to, fromValue);
    }
  });
};

const HYDRATED_SECTIONS = ['transport', 'customer', 'address_config', 'pincode_master', 'customer_allocation_rules', 'hub', 'app_user'];

const tabContributesToShouldShow = (sub: any): boolean => {
  if (!sub || typeof sub !== 'object') return false;
  return sub.read === true;
};

const recomputeDerived = (partsToShow: any, has: Has): void => {
  const spo = get(partsToShow, 'setup_permission_obj');
  if (!spo || typeof spo !== 'object') return;

  const customer = spo.customer;
  if (customer && typeof customer === 'object') {
    customer.inventory_download = customer.setup;
  }

  HYDRATED_SECTIONS.forEach((section) => {
    const sectionObj = spo[section];
    if (sectionObj && typeof sectionObj === 'object') {
      sectionObj.shouldShowTab = Object.keys(sectionObj).some((tab) =>
        tabContributesToShouldShow(sectionObj[tab]));
    }
  });

  const transport = spo.transport;
  partsToShow.setup_transport_module =
    has('transport:read') || (transport && transport.shouldShowTab) || false;
  partsToShow.setup_vehicle_module = has('vehicle:list');
  partsToShow.setup_client_management =
    has('customer:list') || (customer && customer.shouldShowTab) || false;
  partsToShow.setup_address_config =
    has('addresshierarchy:list') || (spo.address_config && spo.address_config.shouldShowTab) || false;
  partsToShow.setup_pincode_master =
    has('pincodemaster:list') || (spo.pincode_master && spo.pincode_master.shouldShowTab) || false;
  partsToShow.setup_client_allocation_rules =
    has('pincodehubrelation:list') || (spo.customer_allocation_rules && spo.customer_allocation_rules.shouldShowTab) || false;
  partsToShow.setup_hubs =
    has('hub:list') || (spo.hub && spo.hub.shouldShowTab) || false;
  partsToShow.setup_app_users =
    has('worker:list') || (spo.app_user && spo.app_user.shouldShowTab) || false;
  partsToShow.setup_appflow_config = has('appflowconfig:list') || false;
  partsToShow.setup_page_builder = has('objectpage:list');
  partsToShow.setup_view_builder = has('objectview:list');
  partsToShow.setup_api_key_management = has('clientintegrationkey:list');
  partsToShow.setup_ops_dashboard_header_mapping = has('headermapping:retrieve');
  partsToShow.setup_delivery_config =
    has('receiverrelation:list') || has('kycdocuments:list') || has('servicetype:list') ||
    has('reschedulereason:list') || has('miscreason:list') || has('merchant:retrieve') || false;
};

export const hydrateFromCaps = (masterData: any, caps: string[]): any => {
  const partsToShow = get(masterData, PARTS_TO_SHOW_PATH);
  if (!partsToShow || !partsToShow.use_permissions_v2) {
    return masterData;
  }

  const capSet = new Set(caps);
  const has: Has = (key) => capSet.has(key);

  const hydrated = cloneDeep(masterData);
  const root = get(hydrated, PARTS_TO_SHOW_PATH);

  MANIFEST.forEach((entry) => {
    const base = entry.base === 'masterData' ? hydrated : root;
    let value = entry.op === 'AND'
      ? entry.keys.every(has)
      : entry.keys.some(has);
    if (entry.orgFlag) {
      value = value && !!get(base, entry.orgFlag);
    }
    set(base, entry.path, value);
  });

  recomputeDerived(root, has);
  return hydrated;
};
